var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"formLabel f-r"},[_c('div',{staticClass:"form-title f-r j-c a-c"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('div',{staticClass:"form-value f-r j-c a-c"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n    "),(_vm.unit && _vm.value !=='0')?_c('span',{staticClass:"unit"},[_vm._v(_vm._s(' ' + _vm.unit))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82346472","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseCloudUp/formLabel.vue
// module id = null
// module chunks = 